export default "__VITE_ASSET__KQJ5IKZ$__"